"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DevelopmentDoc',
  data: function data() {
    return {
      iframeUrl: '',
      iframeSrc: ''
    };
  },
  created: function created() {
    // 默认加载 Document.html，可通过路由参数 url 覆盖
    var defaultUrl = this.$route.query.url || '/Document.html';
    this.iframeUrl = defaultUrl;
    this.iframeSrc = defaultUrl;
  },
  methods: {
    loadIframe: function loadIframe() {
      if (!this.iframeUrl) {
        this.$message({
          type: 'warning',
          message: '请输入页面地址'
        });
        return;
      }
      this.iframeSrc = this.iframeUrl;
    }
  }
};